import { useEffect, useState } from "react";
import { AiOutlineCar } from "react-icons/ai";
import Count from "../../../components/shared/Count";
import fetchVisitsAll from "../../../services/fetchVisistsAll";
import VehiclePanel from "./VehiclePanel";
export default function ArrivedWidget({ site_id }: any) {
  const [showDetails, setShowDetails] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleFetchVehicles = async () => {
    setLoading(true);
    const data = await fetchVisitsAll(site_id);
    const vehicleexists = await data.filter(
      (visit: any) => visit?.vehicle !== null
    );

    const filtered = await vehicleexists.filter(
      (visit: any) => visit?.timein !== visit?.timeout
    );
    setVehicles(filtered);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchVehicles();
  }, []);

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 bg-white border border-gray-300 rounded-lg mx-2 hover:bg-red-100 cursor-pointer mb-2 sm:mb-0">
      <button
        onClick={() => setShowDetails(true)}
        className="py-2 px-3 flex flex-row items-center "
      >
        <div className="bg-green-100 h-16 w-16 rounded-full text-white flex justify-center items-center">
          <AiOutlineCar size={35} color="#4ca832" />
        </div>
        <div className="flex flex-col ml-2 justify-center">
          <div className="text-xs text-blue-900 font-bold uppercase">
            Vehicles Arrived
          </div>
          <div className="flex  justify-between items-center text-sm">
            <div className="rounded-sm text-black text-3xl font-bold">
              <Count isLoading={isLoading} count={vehicles.length} />
            </div>
          </div>
        </div>
      </button>

      <VehiclePanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        vehicles={vehicles}
        title={"Vehicles Arrived"}
      />
    </div>
  );
}
